export const GIT_BRANCH = "master"
export const GIT_HASH = "485e82cda7420b7a350e0729bf2e4596a977c250"
export const BUILD_NUM = "master.2023.12.04.02"
export const THEME_COLOR = "#808080"
export const PRIMARY_COLOR = "#ffffff"
export const TERTIARY_COLOR = "#414142"
export const ASSETS_BASE_URL = "https://web-order.flipdish.co/client/productionwlbuild/latest/"
export const DEFAULT_API_URL = "https://api.flipdish.co/"
export const DEFAULT_PATH_EMBEDDED = "https://web-order.flipdish.co/production/embedded/latest/index.html"
